import styled from 'styled-components';

import { sp } from '@main/theme';

/**
 * Wrapper for history preview
 */
export const RequestHistoryPreviewWrapper = styled.div`
  margin-left: ${sp(1)};
`;
